import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import React, { useEffect, useState } from "react";
import Loader from "react-loaders";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  Col,
  CustomInput,
  Modal,
  ModalHeader,
  Row,
  Input
} from "reactstrap";
import swal from "sweetalert";
import { api } from "../../_services/api.service";
import { AppHelper } from "../../_helpers/appHelper";
import ImageUploadField from "../../Components/ImageUploadField";
import exceptionHandler from "../../_helpers/exceptionHandler";

const MilestoneSettingsModal = ({
  milestoneItem,
  showModal,
  toggleModal,
  phaseTypes,
  reloadList,
}) => {
  let [isLoading, setIsLoading] = useState(false);
  let [isServerProcessing, setIsServerProcessing] = useState(false);
  let [milestone, setMilestone] = useState(milestoneItem);
  let [milestoneTypes, setMilestoneTypes] = useState([]);

  useEffect(() => {
    setMilestone(milestoneItem)
  }, [milestoneItem, showModal]);

  useEffect(() => {
    // load milestone types
    api.getMilestoneTypes()
      .then(data => {
        if (data) { 
          setMilestoneTypes(data)
        };
      });
  }, []);

  const handleSubmit = async (e, errors, values) => {
    if (errors.length > 0)
      return;

    setIsServerProcessing(true);
    if (milestone.milestoneID === -1) { // create new milestone
      await api.createMilestone(milestone)
      .then(created => {
        if (created) toggleModal();
        else AppHelper.showErrorToast();
      })
      .catch(exceptionHandler);
    } else { // update existing milestone
      await api.updateMilestone(milestone)
      .then(created => {
        if (created) toggleModal();
        else AppHelper.showErrorToast();
      })
      .catch(exceptionHandler);
    }

    setIsServerProcessing(false);
    reloadList && reloadList();
  };

  const removeMilestone = () => {
    swal({
      text: "Removing this will also remove the Fields associated to this milestone. Are you sure you want to remove this item?",
      icon: "warning",
      buttons: {
        ok: "Yes",
        cancel: "No",
      },
      dangerMode: true,
    }).then(async (val) => {
      if (val) {
        setIsServerProcessing(true);
        await api.deleteMilestone(milestone.milestoneID)
          .then(deleted => {
            if (deleted) {
              toggleModal();
              reloadList && reloadList();
            } else AppHelper.showErrorToast();
          })
          .catch(exceptionHandler);

        setIsServerProcessing(false);
      }
    });
  };

  const handleImageInputChange = (event) => {
    const fileUploaded = event.target.files[0];
    AppHelper.uploadImage(fileUploaded)
      .then(url => {
        setMilestone({ ...milestone, icon: url });
      });
  };

  return (
    <Modal
      size="lg"
      isOpen={showModal}
      toggle={toggleModal}
      backdrop="static"
    >
      <ModalHeader toggle={toggleModal}>{milestone.milestoneText ? milestone.milestoneText : "New"} milestone</ModalHeader>
      {isLoading && <Loader style={{}} type="ball-pulse" active />}
      {!isLoading && (
        <Row style={{ marginTop: "30px" }}>
          <Col md="12">
            <Card className="main-card mb-3">
              <CardBody>
                <AvForm onSubmit={handleSubmit}>
                  <Row>
                    <Col md="12">
                      <AvField
                        name="milestoneText"
                        label="Milestone *"
                        value={milestone.milestoneText}
                        onChange={(e) =>
                          setMilestone({
                            ...milestone,
                            milestoneText: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                        required
                      />

                      <div className="form-group">
                        <label>Phase</label>
                        <CustomInput
                          type="select"
                          id={"phaseTypeEditable"}
                          value={milestone.phaseID}
                          className="form-control"
                          name={"milestoneTypeEditable"}
                          onChange={(e) => {
                            setMilestone({
                              ...milestone,
                              phaseID: e.target.value,
                            })
                          }}
                        >
                          {phaseTypes.map((x) => {
                            return (
                              <option key={x.id} value={x.id}>
                                {x.name}
                              </option>
                            );
                          })}
                        </CustomInput>
                      </div>

                      <div className="form-group">
                        <label>Milestone Type</label>
                        <CustomInput
                          type="select"
                          id={"milestoneTypeEditable"}
                          value={milestone.milestoneTypeID}
                          className="form-control"
                          name={"milestoneTypeEditable"}
                          onChange={(e) => {
                            setMilestone({
                              ...milestone,
                              milestoneTypeID: e.target.value,
                            })
                          }}
                        >
                          {milestoneTypes.map((x) => {
                            return (
                              <option key={x.id} value={x.id}>
                                {x.type}
                              </option>
                            );
                          })}
                        </CustomInput>
                      </div>

                      <div className="form-group">
                        <label>Order</label>
                        <Input
                          type="number"
                          value={milestone.orderID}
                          onChange={(e) => {
                            let val = e.target.value;
                            if (
                              e.target.value != null &&
                              e.target.value.indexOf(".") !== -1
                            ) {
                              val = e.target.value.split(".")[0];
                            }
                            setMilestone({ ...milestone, orderID: val });
                          }
                          }
                        />
                      </div>

                      <AvField
                        name="contentLink"
                        label="Content Link"
                        value={milestone.contentLink}
                        onChange={(e) =>
                          setMilestone({
                            ...milestone,
                            contentLink: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                      />

                      <ImageUploadField
                        label={"Icon"}
                        imageUri={milestone.icon}
                        handleImageInputChange={handleImageInputChange}
                      />

                      <div className="form-group">
                        <label>Points</label>
                        <Input
                          type="number"
                          value={milestone.points}
                          onChange={(e) => {
                            let val = e.target.value;
                            if (
                              e.target.value != null &&
                              e.target.value.indexOf(".") !== -1
                            ) {
                              val = e.target.value.split(".")[0];
                            }
                            setMilestone({ ...milestone, points: val });
                          }
                          }
                        />
                      </div>

                      <AvField
                        name="introText"
                        label="Intro Text"
                        value={milestone.introText}
                        type="textarea"
                        style={{ height: "100px" }}
                        onChange={(e) =>
                          setMilestone({
                            ...milestone,
                            introText: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                      />

                      <AvField
                        name="extraText"
                        label="Ending Text"
                        value={milestone.extraText}
                        type="textarea"
                        style={{ height: "100px" }}
                        onChange={(e) =>
                          setMilestone({
                            ...milestone,
                            extraText: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                      />

                      <AvField
                        name="unlockMessage"
                        label="Unlock Message"
                        value={milestone.unlockMessage}
                        type="textarea"
                        style={{ height: "100px" }}
                        onChange={(e) =>
                          setMilestone({
                            ...milestone,
                            unlockMessage: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                      />

                      <AvField
                        name="lockReason"
                        label="Lock Reason"
                        value={milestone.lockReason}
                        type="textarea"
                        style={{ height: "100px" }}
                        onChange={(e) =>
                          setMilestone({
                            ...milestone,
                            lockReason: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                      />
                    </Col>
                  </Row>
                  <div className="pull-right">
                    {isServerProcessing && <Loader style={{}} type="ball-pulse" active />}
                    <Button
                      color="primary"
                      type="submit"
                      style={{ marginRight: ".25rem" }}
                      disabled={isServerProcessing}
                    >
                      Save
                    </Button>
                    {milestone.milestoneID !== -1 && <Button disabled={isServerProcessing} color="danger" onClick={() => removeMilestone()}>
                      Delete
                    </Button>}
                    <Button
                      color="link"
                      className="pull-right"
                      onClick={() => toggleModal()}
                    >
                      Cancel
                    </Button>
                  </div>
                </AvForm>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </Modal>
  );
};

MilestoneSettingsModal.propTypes = {
  milestoneItem: PropTypes.shape({
    milestoneID: PropTypes.number,
    milestoneText: PropTypes.string,
    phaseText: PropTypes.string,
    milestoneType: PropTypes.string,
    milestoneTypeID: PropTypes.number,
    orderID: PropTypes.number,
    contentLink: PropTypes.string,
    icon: PropTypes.string,
    points: PropTypes.number,
    introText: PropTypes.string,
    unlockMessage: PropTypes.string,
    extraText: PropTypes.string,
    lockReason: PropTypes.string,
  }),
  showModal: PropTypes.bool,
  toggleModal: PropTypes.func,
  phaseTypes: PropTypes.array
};

MilestoneSettingsModal.defaultProps = {
  milestoneItem: {
    milestoneID: -1,
    milestoneText: "",
    phaseText: "",
    milestoneType: "",
    milestoneTypeID: 0,
    orderID: -1,
    contentLink: "",
    icon: "",
    points: 0,
    introText: "",
    unlockMessage: "",
    extraText: "",
    lockReason: ""
  },
  showModal: false,
  phaseTypes: []
};

export default MilestoneSettingsModal;